import * as React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
    columnsCount: number;
    page: number;
    totalCount: number;
    pageSize: number;
    //  url?: string;
    move: string | ((page: number) => void);
}



export const TableFooterPager: React.StatelessComponent<Props> = (props) => {

    const renderButtons = () => {
        if (props.move instanceof Function) {
            const moveTo: (page: number) => void = props.move as ((page: number) => void);

            return <div>
                <Button onClick={(e: any) => { moveTo(1); }} className={btnPrevClass}><FontAwesomeIcon icon="step-backward" /></Button>
                &nbsp;
                        <Button onClick={(e: any) => { moveTo(prevPage); }} className={btnPrevClass}><FontAwesomeIcon icon="chevron-left" /></Button>
                &nbsp;&nbsp;
                            Страница <input type="text" value={props.page} onChange={(e) => { }} style={{ width: "30px", textAlign: "center" }} /> из {lastPage}
                &nbsp;&nbsp;
                        <Button onClick={(e: any) => { moveTo(nextPage); }} className={btnNextClass}><FontAwesomeIcon icon="chevron-right" /></Button>
                &nbsp;
                        <Button onClick={(e: any) => { moveTo(lastPage); }} className={btnNextClass}><FontAwesomeIcon icon="step-forward" /></Button>
            </div>;
        }
        else
            return <div>
                <Link to={`${props.move}/1`} className={btnPrevClass}><FontAwesomeIcon icon="step-backward" /></Link>
                &nbsp;
                        <Link to={`${props.move}/${prevPage}`} className={btnPrevClass}><FontAwesomeIcon icon="chevron-left" /></Link>
                &nbsp;&nbsp;
                            Страница <input type="text" value={props.page} onChange={(e) => { }} style={{ width: "30px", textAlign: "center" }} /> из {lastPage}
                &nbsp;&nbsp;
                        <Link to={`${props.move}/${nextPage}`} className={btnNextClass}><FontAwesomeIcon icon="chevron-right" /></Link>
                &nbsp;
                        <Link to={`${props.move}/${lastPage}`} className={btnNextClass}><FontAwesomeIcon icon="step-forward" /></Link>
            </div>
    }

    const renderFooter = () => {
        if (props.totalCount <= props.pageSize)
            return <tfoot></tfoot>;

        return <tfoot className='clearfix text-center'>
            <tr>
                <td colSpan={props.columnsCount} style={{ "fontSize": "12px" }}>
                    <Row>
                        <Col sm={6} className="text-left">
                            {renderButtons()}
                        </Col>
                        <Col sm={6} className="text-right">
                            Показано записей {(props.page - 1) * props.pageSize + 1} - {(props.page) * props.pageSize} из {props.totalCount}
                        </Col>
                    </Row>

                </td>
            </tr>
        </tfoot>
    }

    const prevPage = (props.page || 0) - 1;
    let nextPage = (props.page || 0) + 1;
    const lastPage = Math.ceil(props.totalCount / props.pageSize);
    const btnNextClass = `btn btn-xs btn-default ${nextPage > lastPage ? 'disabled' : ''}`;
    const btnPrevClass = `btn btn-xs btn-default ${prevPage < 1 ? 'disabled' : ''}`;
    if (nextPage > lastPage) nextPage = lastPage;
    return renderFooter();
};
